// src/modules/AutoMessageModule.js
import Vue from 'vue'

const state = {
  rules: [],
  loading: false,
  saving: false,
}

const mutations = {
  SET_RULES(state, rules) { state.rules = rules },
  SET_LOADING(state, v)   { state.loading = v },
  SET_SAVING(state, v)    { state.saving = v },
}

function extractErrorMessage(err) {
  const resp = err && err.response ? err.response : null
  const body = resp ? resp.data : null

  if (typeof body === 'string' && body.trim()) return body
  if (body && body.message) return body.message
  if (body && body.error)   return body.error
  if (err && err.message)   return err.message
  return 'Failed to process request. Please try again.'
}

const actions = {
  async fetchAutoMessageRules({ commit, rootState }) {
    commit('SET_LOADING', true)
    try {
      const url  = rootState.apiUrl + '/automessage-rules'
      const resp = await Vue.prototype.$http.get(url, {
        headers: { Authorization: 'Bearer ' + rootState.token }
      })

      const raw  = resp && resp.data ? resp.data : []
      const data = Array.isArray(raw) ? raw : []

      commit('SET_RULES', data)
    } catch (err) {
      console.error('[automessage-rules] fetch failed:',
        (err && err.response && err.response.data) || err)
      commit('SET_RULES', [])
      throw err
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveAutoMessageRule({ commit, dispatch, rootState }, { rule, isEditing }) {
    commit('SET_SAVING', true)
    try {
      const url    = isEditing
        ? rootState.apiUrl + '/automessage-rules/' + rule.id
        : rootState.apiUrl + '/automessage-rules'
      const method = isEditing ? 'put' : 'post'

      await Vue.prototype.$http({
        method,
        url,
        data: rule,
        headers: { Authorization: 'Bearer ' + rootState.token }
      })

      await dispatch('fetchAutoMessageRules')
      return {
        success: true,
        message: 'Auto message rule ' + (isEditing ? 'updated' : 'added') + ' successfully.'
      }
    } catch (err) {
      const msg = extractErrorMessage(err)
      console.error('[automessage-rules] save failed:', msg)
      throw new Error(msg)
    } finally {
      commit('SET_SAVING', false)
    }
  },

  async deleteAutoMessageRule({ commit, dispatch, rootState }, ruleId) {
    commit('SET_SAVING', true)
    try {
      const url = rootState.apiUrl + '/automessage-rules/' + ruleId
      await Vue.prototype.$http.delete(url, {
        headers: { Authorization: 'Bearer ' + rootState.token }
      })

      await dispatch('fetchAutoMessageRules')
      return { success: true, message: 'Rule deleted successfully.' }
    } catch (err) {
      const msg = extractErrorMessage(err)
      console.error('[automessage-rules] delete failed:', msg)
      throw new Error(msg)
    } finally {
      commit('SET_SAVING', false)
    }
  }
}

const getters = {
  rules:      s => s.rules,
  loading:    s => s.loading,
  saving:     s => s.saving,
  rulesCount: s => s.rules.length,
}

export const AutoMessageModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
